export default "__VITE_ASSET__NKhZ0OLb__"